<template>
    <div>
        <el-descriptions title="执裁经历" style="margin-top: 15px"></el-descriptions>
        <el-row>
            <el-table
                style="width: 100%"
                :data="list"
                border
                size="mini"
                :empty-text="eventsId ? '学员未提交执裁经历' : '未上传执裁经历'" 
            >
                <el-table-column label="开始时间" align="center" width="120px">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.HoldTime.BeginTime, 'yyyy-MM-dd')}}
                    </template>
                </el-table-column>
                <el-table-column label="结束时间" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.HoldTime.EndTime">{{formatDate(scope.row.HoldTime.EndTime, 'yyyy-MM-dd')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="JudgeLeague" label="执裁赛事" align="center"></el-table-column>
                <el-table-column label="举办地点" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.HoldPlace">{{scope.row.HoldPlace.RegionName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="执裁比赛数" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.MatchCount > 0">{{scope.row.MatchCount}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100px">
                    <template slot-scope="scope">
                        <el-button type="text" @click="lookDetail(scope.row.ExperienceId)">查看</el-button>
                    </template>
                </el-table-column>
                <template #append>
                    <div class="load_more" v-show="moreStatus == 'more'" @click="getDataList()">点击加载更多执裁经历</div>
                </template>
            </el-table>
        </el-row>
        <el-dialog
            :title="`${userName}的执裁经历`"
            :visible.sync="visible"
            width="600px" append-to-body>
             <el-descriptions title="赛事基本信息" :column="1" :labelStyle="labelStyle" v-if="BaseInfo">
                <el-descriptions-item label="运动项目" v-if="BaseInfo.EventsName">{{BaseInfo.EventsName}}</el-descriptions-item>
                <el-descriptions-item label="赛季名称" v-if="BaseInfo.JudgeLeague">{{BaseInfo.JudgeLeague}}</el-descriptions-item>
                <el-descriptions-item label="举办地点" v-if="locationText">{{locationText}}</el-descriptions-item>
                <el-descriptions-item label="举办时间" v-if="dateText">{{dateText}}</el-descriptions-item>
                <el-descriptions-item label="主办单位" v-if="BaseInfo.HostUnit">{{BaseInfo.HostUnit}}</el-descriptions-item>
                <el-descriptions-item label="赛事规模" v-if="BaseInfo.LeagueScale">{{BaseInfo.LeagueScale}}</el-descriptions-item>
                <el-descriptions-item label="其他说明" v-if="BaseInfo.Remarks">
                    <p v-html="BaseInfo.Remarks.replace(/[\r\n]+/g, '<br/>')"></p>
                </el-descriptions-item>
                <el-descriptions-item label="赛事照片" v-if="BaseInfo.WorkVouchers">
                    <div class="images">
                        <img v-for="url in BaseInfo.WorkVouchers" :key="url" :src="ossThumb(url)" @click="imagePreview(url, BaseInfo.WorkVouchers)" />
                    </div>
                </el-descriptions-item>
             </el-descriptions>
             <el-descriptions title="执裁比赛信息"  v-if="MatchList && MatchList.length" style="margin-top: 15px"></el-descriptions>
             <el-collapse accordion  v-if="MatchList && MatchList.length">
                <el-collapse-item :title="getMatchTitle(item, index)" v-for="(item, index) in MatchList" :key="index">
                    <el-descriptions :column="1" :labelStyle="labelStyle">
                        <el-descriptions-item label="比赛场馆" v-if="item.MatchVenue">{{item.MatchVenue}}</el-descriptions-item>
                        <el-descriptions-item label="比赛时间" v-if="item.MatchTime">{{formatDate(item.MatchTime)}}</el-descriptions-item>
                        <el-descriptions-item label="赛事阶段" v-if="item.LeagueProgress">{{item.LeagueProgress}}</el-descriptions-item>
                        <el-descriptions-item label="主队名称" v-if="item.HomeTeam">{{item.HomeTeam}}</el-descriptions-item>
                        <el-descriptions-item label="客队名称" v-if="item.AwayTeam">{{item.AwayTeam}}</el-descriptions-item>
                        <el-descriptions-item label="比赛结果" v-if="item.MatchResult">{{item.MatchResult}}</el-descriptions-item>
                        <el-descriptions-item label="执裁身份" v-if="item.RefereeRoleName">{{item.RefereeRoleName}}</el-descriptions-item>
                        <el-descriptions-item label="执裁小结" v-if="item.Remarks">
                             <p v-html="item.Remarks.replace(/[\r\n]+/g, '<br/>')"></p>
                        </el-descriptions-item>
                        <el-descriptions-item label="比赛照片" v-if="item.MatchPictures">
                            <div class="images">
                                <img v-for="url in item.MatchPictures" :key="url" :src="ossThumb(url)" @click="imagePreview(url, item.MatchPictures)" />
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
            </el-collapse>
            <template #footer>
                <el-button @click="close">关闭</el-button>
            </template>
        </el-dialog>
        <el-image ref="imagePreview" class="image_preview"
            :src="imagePreviewUrl" 
            :preview-src-list="imagePreviews">
        </el-image>
    </div>
</template>
<script>
import utils from '@/utils';
export default {
    name: 'RefereeExperienceList',
    props:{
        userName: String,
        userId: {
            type: Number,
            default: 0
        },
        eventsId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            visible: false,
            list: [],
            moreStatus: '',
            experienceDetail: {},
            imagePreviews: [],
            imagePreviewUrl: ''
        };
    },
    computed: {
        labelStyle(){
            return {'width':'100px','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'};
        },
        BaseInfo(){
            return this.experienceDetail.BaseInfo;
        },
        MatchList(){
            return this.experienceDetail.MatchList;
        },
        dateText(){
            if(!this.BaseInfo) return '';
            let {
                BeginTime,
                EndTime
            } = this.BaseInfo.HoldTime;
            if(BeginTime && EndTime){
                return `${this.formatDate(BeginTime, 'yyyy-MM-dd')} 至 ${this.formatDate(EndTime, 'yyyy-MM-dd')}`;
            }
            return '';
        },
        locationText(){
            if(!this.BaseInfo) return '';
            let {
                HoldPlace
            } = this.BaseInfo;
            return (HoldPlace || {}).RegionName || '';
        },
        lastId() {
            let length = this.list.length;
            if (length > 0) {
                return this.list[length - 1].ExperienceId;
            }
            return 0;
        }
    },
    watch: {
        userId: {
            immediate: true,
            handler(newValue){
                if(newValue){
                    this.getDataList(true);
                }
            }
        },
        eventsId: {
            immediate: true,
            handler(newValue){
                if(newValue){
                    this.getDataList(true);
                }
            }
        }
    },
    methods: {
        formatDate(value, format = 'yyyy-MM-dd hh:mm'){
            return utils.dateFormat(value, format);
        },
        ossThumb(url){
            return url + '?x-oss-process=style/thumb_300';
        },
        getMatchTitle(item, index){
            let text = `第${index + 1}场`;
            let {
                MatchTime,
                HomeTeam,
                AwayTeam
            } = item;
            if(HomeTeam && AwayTeam){
                text += ` ${HomeTeam} vs ${AwayTeam} `;
            }
            if(MatchTime){
                text += this.formatDate(MatchTime, 'MM-dd hh:mm');
            }
            return text;
        },
        getDataList(isReload){
            if(!isReload && ['loading', 'noMore']) return;
            let lastId = isReload ? 0 : this.lastId;
            this.moreStatus = 'loading';
            this.$api.GetUserRefereeExperienceList({
                "RefereeUserId": this.userId,
                "Continuation": {
                    "LastId": lastId,
                    "MaxCount": 20
                },
                "EventsId": this.eventsId
            }).then(data=>{
                this.moreStatus = 'more';
                if(data.Code == 0){
                    let list = data.ContinueList || [];
                    if(list.length > 0){
                        if(isReload){
                            this.list = [...list];
                        }else{
                            this.list.push(...list);
                        }
                        if(list.length < 20){
                            this.moreStatus = 'noMore';
                        }
                    }else{
                        this.moreStatus = 'noMore';
                    }
                }
            })
        },
        open(){
            this.visible = true;
        },
        close(){
            this.visible = false;
        },
        lookDetail(id){
            this.$api.GetUserRefereeExperienceDetail({
                "ExperienceId": id
            }).then(data=>{
                if(data.Code == 0){
                    this.experienceDetail = data.ExperienceDetail;
                    this.open();
                }
            })
        },
        imagePreview(url, imgs){
            if(imgs.length){
                this.imagePreviews = imgs;
                this.imagePreviewUrl = url;
                this.$refs.imagePreview.showViewer = true;
            }
        }
    }
};
</script>
<style scoped>
@import "~@/assets/css/clear-el.css";
.load_more{
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
    box-sizing: border-box;
    cursor: pointer;
}
.load_more:hover{
    color: #409EFF;
}
.images img{
    width: 100px;
    height: 100px;
    cursor: pointer;
    object-fit: cover;
    margin-right: 5px;
    margin-bottom: 5px;
    
}
</style>